export const SET_SIGN_UP_ACCOUNT_TYPE = 'SET_SIGN_UP_ACCOUNT_TYPE';
export const setSignUpAccountType = (data) => ({
	type: SET_SIGN_UP_ACCOUNT_TYPE,
	data,
});

/*
 * SIGN UP ACTION FACTORY
 */
export const signUpAction = (actionType, name) => (value) => {
	return {
		type: actionType,
		name,
		value,
	};
};

export const SET_PROGRESS_STEP = 'SET_PROGRESS_STEP';
export const setProgressStep = (stepCompletedIndex) => {
	return signUpAction(SET_PROGRESS_STEP, `progress-step-${stepCompletedIndex}`)(true);
};

export const SET_SKIP_BANK_LINK = 'SET_SKIP_BANK_LINK';
export const setSkipBankLink = signUpAction(SET_SKIP_BANK_LINK, 'skip-bank-link');

export const SET_COMPLETED_REFERRAL = 'SET_COMPLETED_REFERRAL';
export const setCompletedReferral = signUpAction(SET_COMPLETED_REFERRAL, 'referral');

// TODO: Remove this once billing frequency is tested.
export const SET_BILLING_PERIOD = 'SET_BILLING_PERIOD';
export const setBillingPeriod = (billingPeriod) => ({
	type: SET_BILLING_PERIOD,
	billing_period: billingPeriod,
});

export const SET_BILLING_FREQUENCY = 'SET_BILLING_FREQUENCY';
export const setBillingFrequency = (billing_frequency_id) => ({
	type: SET_BILLING_FREQUENCY,
	billing_frequency_id,
});

export const SET_BILLING_FREQUENCIES = 'SET_BILLING_FREQUENCIES';
export const setBillingFrequencies = (billingFrequencies) => ({
	type: SET_BILLING_FREQUENCIES,
	billingFrequencies,
});

export const SET_BILLING_SUMMARY = 'SET_BILLING_SUMMARY';
export const setBillingSummary = signUpAction(SET_BILLING_SUMMARY, 'billing-summary');

export const SET_CONFIRM_TRANSFER = 'SET_CONFIRM_TRANSFER';
export const setConfirmTransfer = signUpAction(SET_CONFIRM_TRANSFER, 'confirm-transfer');

export const SET_TRANSFER_COMPLETE = 'SET_TRANSFER_COMPLETE';
export const setTransferComplete = signUpAction(
	SET_TRANSFER_COMPLETE,
	'transfer-complete'
);

export const SET_EMPLOYED = 'SET_EMPLOYED';
export const setEmployed = signUpAction(SET_EMPLOYED, 'employed');

export const SET_ONE_TIME_TRANSFER_VALUE_PROP = 'SET_ONE_TIME_TRANSFER_VALUE_PROP';
export const setOneTimeTransferValueProp = signUpAction(
	SET_ONE_TIME_TRANSFER_VALUE_PROP,
	'one-time-transfer-value-prop'
);

export const SET_ONE_TIME_TRANSFER = 'SET_ONE_TIME_TRANSFER';
export const setOneTimeTransfer = (amount) => ({
	type: SET_ONE_TIME_TRANSFER,
	amount,
});

export const SET_ONE_TIME_TRANSFER_COMPLETE = 'SET_ONE_TIME_TRANSFER_COMPLETE';
export const setOneTimeTransferComplete = signUpAction(
	SET_ONE_TIME_TRANSFER_COMPLETE,
	'one-time-transfer'
);

export const SET_ONE_TIME_TRANSFER_SKIP = 'SET_ONE_TIME_TRANSFER_SKIP';
export const setOneTimeTransferSkip = signUpAction(
	SET_ONE_TIME_TRANSFER_SKIP,
	'one-time-transfer-skip'
);

export const SET_ONE_TIME_TRANSFER_CONFIRM = 'SET_ONE_TIME_TRANSFER_CONFIRM';
export const setOneTimeTransferConfirm = signUpAction(
	SET_ONE_TIME_TRANSFER_CONFIRM,
	'one-time-transfer-confirm'
);

export const SET_RECURRING_TRANSFER_VALUE_PROP = 'SET_RECURRING_TRANSFER_VALUE_PROP';
export const setRecurringTransferValueProp = signUpAction(
	SET_RECURRING_TRANSFER_VALUE_PROP,
	'recurring-transfer-value-prop'
);

export const SET_RECURRING_TRANSFER = 'SET_RECURRING_TRANSFER';
export const setRecurringTransfer = signUpAction(
	SET_RECURRING_TRANSFER,
	'recurring-transfer'
);

export const SET_RECURRING_TRANSFER_CONFIRM = 'SET_RECURRING_TRANSFER_CONFIRM';
export const setRecurringTransferConfirm = signUpAction(
	SET_RECURRING_TRANSFER_CONFIRM,
	'recurring-transfer-confirm'
);

export const SET_RECURRING_TRANSFER_SKIP = 'SET_RECURRING_TRANSFER_SKIP';
export const setRecurringTransferSkip = signUpAction(
	SET_RECURRING_TRANSFER_SKIP,
	'recurring-transfer-skip'
);

export const SET_EXPLORE_ADVICE_COMPLETE = 'SET_EXPLORE_ADVICE_COMPLETE';
export const setExploreAdviceComplete = signUpAction(
	SET_EXPLORE_ADVICE_COMPLETE,
	'explore-advice'
);

export const SET_ADD_TRUSTED_CONTACT = 'SET_ADD_TRUSTED_CONTACT';
export const setAddTrustedContact = signUpAction(
	SET_ADD_TRUSTED_CONTACT,
	'add-trusted-contact'
);

export const SET_WELCOME_TO_STASH_COMPLETE = 'SET_WELCOME_TO_STASH_COMPLETE';
export const setWelcomeToStash = signUpAction(
	SET_WELCOME_TO_STASH_COMPLETE,
	'set-welcome-to-stash-complete'
);

export const SET_SCHEDULE_COMPLETE = 'SET_SCHEDULE_COMPLETE';
export const setScheduleComplete = signUpAction(
	SET_SCHEDULE_COMPLETE,
	'set-schedule-complete'
);

export const SET_AUTO_INVEST_SMART_SUMMARY_COMPLETE =
	'SET_AUTO_INVEST_SMART_SUMMARY_COMPLETE';
export const setAutoInvestSmartSummaryComplete = signUpAction(
	SET_AUTO_INVEST_SMART_SUMMARY_COMPLETE,
	'set-auto-invest-smart-summary-complete'
);

export const SET_SMART_SUCCESS_COMPLETE = 'SET_SMART_SUCCESS_COMPLETE';
export const setSmartSuccessComplete = signUpAction(
	SET_SMART_SUCCESS_COMPLETE,
	'set-smart-success-complete'
);

export const SET_ONBOARDING_COMPLETE = 'SET_ONBOARDING_COMPLETE';
export const setOnboardingComplete = signUpAction(
	SET_ONBOARDING_COMPLETE,
	'set-onboarding-complete'
);

export const SET_AUTO_INVEST_MIX = 'SET_AUTO_INVEST_MIX';
export const setAutoInvestMix = signUpAction(SET_AUTO_INVEST_MIX, 'set-auto-invest-mix');

export const SET_BANK_LINK_OAUTH = 'SET_BANK_LINK_OAUTH';
export const setBankLinkOAuth = signUpAction(SET_BANK_LINK_OAUTH, 'bank-link-oauth');

export const SET_ADD_CASH = 'SET_ADD_CASH';
export const setAddCash = signUpAction(SET_ADD_CASH, 'set-add-cash');

export const SET_ADD_CASH_AMOUNT_COMPLETE = 'SET_ADD_CASH_AMOUNT_COMPLETE';
export const setAddCashAmountComplete = signUpAction(
	SET_ADD_CASH_AMOUNT_COMPLETE,
	'set-add-cash-amount-complete'
);

export const SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE =
	'SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE';
export const setAutoInvestAddCashSummaryComplete = signUpAction(
	SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE,
	'set-add-cash-summary-complete'
);

export const SET_ADD_CASH_SUCCESS_COMPLETE = 'SET_ADD_CASH_SUCCESS_COMPLETE';
export const setAddCashSuccessComplete = signUpAction(
	SET_ADD_CASH_SUCCESS_COMPLETE,
	'set-add-cash-success-complete'
);

export const SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE =
	'SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE';
export const setSmartPortfolioAllocationComplete = signUpAction(
	SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE,
	'smart-portfolio-allocation-complete'
);

export const SET_SMART_PORTFOLIO_TRANSITION_COMPLETE =
	'SET_SMART_PORTFOLIO_TRANSITION_COMPLETE';
export const setSmartPortfolioTransitionComplete = signUpAction(
	SET_SMART_PORTFOLIO_TRANSITION_COMPLETE,
	'smart-portfolio-transition-complete'
);

export const SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE =
	'SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE';
export const setSmartPortfolioV2TransitionComplete = signUpAction(
	SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE,
	'smart-portfolio-v2-transition-complete'
);

export const SET_INVESTMENT_SELECTION_COMPLETE = 'SET_INVESTMENT_SELECTION_COMPLETE';
export const setInvestmentSelectionComplete = signUpAction(
	SET_INVESTMENT_SELECTION_COMPLETE,
	'set-investment-selection-complete'
);

export const SET_INVESTMENT_DETAIL_COMPLETE = 'SET_INVESTMENT_DETAIL_COMPLETE';
export const setInvestmentDetailComplete = signUpAction(
	SET_INVESTMENT_DETAIL_COMPLETE,
	'set-investment-detail-complete'
);

export const SKIP_TO_LINK_BANK_PRIMER = 'SKIP_TO_LINK_BANK_PRIMER';
export const skipToLinkBankPrimer = signUpAction(
	SKIP_TO_LINK_BANK_PRIMER,
	'skip-to-link-bank-primer'
);

export const SET_LINK_BANK_PRIMER_COMPLETE = 'SET_LINK_BANK_PRIMER_COMPLETE';
export const setLinkBankPrimerComplete = signUpAction(
	SET_LINK_BANK_PRIMER_COMPLETE,
	'set-link-bank-primer-complete'
);

export const SET_LINK_BANK_LATER = 'SET_LINK_BANK_LATER';
export const setLinkBankLater = signUpAction(SET_LINK_BANK_LATER, 'set-link-bank-later');

export const SET_DUPLICATE_SSN_BLOCK_SCREEN = 'SET_DUPLICATE_SSN_BLOCK_SCREEN';
export const setDuplicateSSNBlockScreen = signUpAction(
	SET_DUPLICATE_SSN_BLOCK_SCREEN,
	'set-duplicate-ssn-block-screen'
);

export const SET_VALID_SSN_COMPLETE = 'SET_VALID_SSN_COMPLETE';
export const setValidSSNComplete = signUpAction(
	SET_VALID_SSN_COMPLETE,
	'valid-ssn-complete'
);

export const SET_STATE_ZERO_HOME_COMPLETE = 'SET_STATE_ZERO_HOME_COMPLETE';
export const setStateZeroHomeComplete = signUpAction(
	SET_STATE_ZERO_HOME_COMPLETE,
	'set-state-zero-home-complete'
);

export const SET_STATE_ZERO_PRIMER_COMPLETE = 'SET_STATE_ZERO_PRIMER_COMPLETE';
export const setStateZeroPrimerComplete = signUpAction(
	SET_STATE_ZERO_PRIMER_COMPLETE,
	'set-state-zero-primer-complete'
);

export const SET_IDV_CHECK_LOADER_COMPLETE = 'SET_IDV_CHECK_LOADER_COMPLETE';
export const setIDVCheckLoaderComplete = signUpAction(
	SET_IDV_CHECK_LOADER_COMPLETE,
	'set-idv-check-loader-complete'
);

export const SET_IDV_SUCCESS_COMPLETE = 'SET_IDV_SUCCESS_COMPLETE';
export const setIDVSuccessComplete = signUpAction(
	SET_IDV_SUCCESS_COMPLETE,
	'set-idv-success-complete'
);

export const SET_PLAN_SELECTION_COMPLETE = 'SET_PLAN_SELECTION_COMPLETE';
export const setPlanSelectionComplete = signUpAction(
	SET_PLAN_SELECTION_COMPLETE,
	'set-plan-selection-complete'
);
